import { jsx as L } from "react/jsx-runtime";
import { SvgIcon as e } from "../SvgIcon.js";
const i = (o) => /* @__PURE__ */ L(e, { ...o, children: /* @__PURE__ */ L(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM7.90098 9.02699L10.616 11.742L15.4182 6.93974L16.25 7.7715L10.616 13.4055L7.06922 9.85876L7.90098 9.02699ZM6.59055 11.0358L5.7274 10.1648L4.58176 9.02699L3.75 9.85876L7.29677 13.3977L8.12853 12.5738L6.59055 11.0358ZM9.78299 9.26068L12.1023 6.94141L12.929 7.76814L10.6097 10.0874L9.78299 9.26068Z"
  }
) });
export {
  i as DoubleTick
};
//# sourceMappingURL=DoubleTick.js.map
